module.exports = __webpack_public_path__ + "img/Dantam Makeover 32.e7a075f7.jpg";